import React, {Component} from 'react';
import 'antd/dist/antd.css';
import Expand from '../../../3th_party/Expand';
import CommonInfo from './CommonInfo';

class HandleOutside extends Component {
  constructor(props) {
    super(props);
    this.state = {
      visible: false,
    }
    
    this.handleClickOutside = this.handleClickOutside.bind(this);
    this.handleClickDrawer = this.handleClickDrawer.bind(this);
    this.drawer = {};
  }
  
  toggleDrawer = () => {
    this.setState({visible: !this.state.visible},
    )
  }
  
  componentDidMount() {
    document.addEventListener('mousedown', this.handleClickDrawer, false);
  }
  
  componentWillUnmount() {
    document.removeEventListener('mousedown', this.handleClickDrawer, false)
  }
  
  handleClickDrawer(e) {
    if (this.drawer.contains(e.target)) {
      return
    }
    this.handleClickOutside();
  }
  
  handleClickOutside() {
    this.setState({visible: false});
  }
  
  handleClickDrawer1(e) {
    if (this.drawer.contains(e.target)) {
      return
    }
    this.handleClickOutside();
  }
  
  render() {
    let avatar = window._.get(this.props.info, 'avatar', '');

    return (
      <div className="d-flex" ref={node => this.drawer = node}>
        {avatar === '' ? <span onClick={this.toggleDrawer} style={{fontSize: 26}} className="icon-user"/> : (
          <div
            onClick={this.toggleDrawer}
            style={{
              backgroundImage: `url("${avatar}")`,
              height: '32px',
              width: '32px',
              backgroundSize: 'contain',
              borderRadius: '50%',
              display: 'block',
              backgroundRepeat: 'no-repeat',
            }}
          />
        )}

        <Expand
          open={this.state.visible}
          styles={{
            open: {
              position: 'absolute',
              display: "block",
              zIndex: 2,
              top: '100%',
              width: '311px',
              textAlign: 'left',
              backgroundColor: '#3d4044',
              right: '8%',
            },
            close: {
              position: 'absolute',
              zIndex: -1,
              display: "block",
              top: '100%',
              width: '311px',
              textAlign: 'left',
              backgroundColor: '#3d4044',
              right: '8%',
            },
          }}
        >
          <CommonInfo info={this.props.info} history={this.props.history} logout={this.props.logout}/>
        </Expand>
      </div>
    )
  }
}

export default HandleOutside;
